import React from "react";
import { Localize } from 'components/service';
import GraphicPackingFields from '../fields';
import { timeFormat } from "utils/helper-functions";


const graphicPackingColumns = [
    {
        title: <Localize>TABLES.Column_Title_Exhibition</Localize>,
        dataIndex: 'title',
        columnIndex: 'TITLE',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_ConstractionStarts</Localize>,
        dataIndex: 'start_build_at',
        columnIndex: 'START_BUILD_AT',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_EventStarts</Localize>,
        dataIndex: 'start_event_at',
        columnIndex: 'START_EVENT_AT',
        sorter: true,
    },
    {
        title: <Localize>TABLES.Column_Title_GraphicAmount</Localize>,
        dataIndex: 'stands_count',
        columnIndex: 'STANDS_COUNT',
        sorter: true,
    },
    {
        dataIndex: 'action',
        columnIndex: 'ACTION',
        align: 'right',
        width: '4%',
    },
];

const graphicPackingData = (items) => {
    if (!items)
    {
        return [];
    }

    return items.map((item) => {
        return {
            key: item.id,
            title: <GraphicPackingFields.Link id={ item.id } title={ item.title } />,
            start_build_at: timeFormat(item?.start_build_at) ?? <strong>&mdash;</strong>,
            start_event_at: timeFormat(item?.start_event_at) ?? <strong>&mdash;</strong>,
            stands_count:
                <GraphicPackingFields.View
                    id={ item.id }
                    count={ item.stands_count }
                    model={ "packed-list" } />,
            action: <GraphicPackingFields.Action record={ item } />,
        };
    });
};

const GraphicPackingTableHelper = {
    columns: graphicPackingColumns,
    data: graphicPackingData,
};

export default GraphicPackingTableHelper;
